import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import moment from 'moment';
import Pagination from 'components/v2/Pagination';
import Spinner from 'components/ui/Spinner';
const Loading = function () {
    return (React.createElement("div", { "data-testid": "div-4479fb1d", className: "absolute justify-center w-full", style: { top: '50%' } },
        React.createElement("div", { "data-testid": "div-71c77b0c", className: "align-middle" },
            React.createElement("span", { "data-testid": "span-49e1ecfd", className: "text-5xl text-green" },
                React.createElement(Spinner, { dataTestId: "Spinner-c9a1ec65", showMessage: false })))));
};
export default function LaneRateAuditTable({ items, perPage, page, pages, total, onPageClick, loading, }) {
    const { t } = useTranslation();
    function handlePageClick(selectedPage) {
        onPageClick(selectedPage);
    }
    function renderHeader(title) {
        return (React.createElement("div", { "data-testid": "div-f3c0cc37", className: "flex whitespace-nowrap" }, t(title)));
    }
    function renderLane(item) {
        return (React.createElement("div", { "data-testid": "div-740059c0", className: "flex flex-col whitespace-nowrap" },
            React.createElement("p", { "data-testid": "p-0d7de4f9" },
                React.createElement("b", { "data-testid": "b-2334ac32" },
                    titleize(t('ORIGIN')),
                    ":"),
                " ",
                item.originCity,
                " - ",
                item.originZip),
            React.createElement("p", { "data-testid": "p-faff1176" },
                React.createElement("b", { "data-testid": "b-f594ae35" },
                    titleize(t('DESTINATION')),
                    ":"),
                " ",
                item.destinationCity,
                " - ",
                item.destinationZip)));
    }
    function renderTimestamp(createdAt) {
        if (!createdAt || !moment(createdAt).isValid()) {
            return t('INVALID_DATE');
        }
        return moment(createdAt).format('YYYY-MM-DD HH:mm:ss');
    }
    if (loading) {
        return Loading();
    }
    return (React.createElement("div", { "data-testid": "div-31ef48de", className: "overflow-x-auto w-full" },
        React.createElement("table", { "data-testid": "table-d68d9e75", className: "default-table w-full" },
            React.createElement("thead", { "data-testid": "thead-7391e5be" },
                React.createElement("tr", { "data-testid": "tr-065f06d6" },
                    React.createElement("th", { "data-testid": "th-bede4656" }, renderHeader('CUSTOMER')),
                    React.createElement("th", { "data-testid": "th-d102ea67" }, renderHeader('LANE')),
                    React.createElement("th", { "data-testid": "th-e9cd222c" }, renderHeader('EVENT')),
                    React.createElement("th", { "data-testid": "th-b330f606" }, renderHeader('TIMESTAMP')),
                    React.createElement("th", { "data-testid": "th-0c7402f0" }, renderHeader('SOURCE')))),
            React.createElement("tbody", { "data-testid": "tbody-ace833e3" }, items.map((item, i) => {
                return ((React.createElement("tr", { "data-testid": `tr-b00480cd-${i}`, key: i, className: i === items.length - 1 ? 'border-b' : '' },
                    React.createElement("td", { "data-testid": `td-bae37c5a-${i}` }, item.customer),
                    React.createElement("td", { "data-testid": `td-361ffe26-${i}` }, renderLane(item)),
                    React.createElement("td", { "data-testid": `td-1eb0d976-${i}` }, item.message),
                    React.createElement("td", { "data-testid": `td-5621a47f-${i}` }, renderTimestamp(item.createdAt)),
                    React.createElement("td", { "data-testid": `td-4012b4e7-${i}` }, item.user))));
            }))),
        React.createElement(Pagination, { dataTestId: "Pagination-443d293c", className: "border-none", perPage: perPage, page: page, pages: pages, total: total, showCount: true, paginationContainerClassName: "mx-auto my-0 sticky right-2/4", onPageClick: handlePageClick })));
}
